import React from "react";
import Page from "./elements_responsive_static/Page";
import { QueryClientProvider } from "react-query";
// import { queryClient } from "../../juntion"
import { queryClient } from "../../query";
import PageDynamic from "./elements_responsive_static/forai/PageDynamic";
import PageDynamicNew from "./elements_responsive_static/forai/PageDynamicNew";


export function RenderPage({
	page_info,
	data,
	gs,
	pageBeforeData,
	pageAfterData,
	ctx,
	query,
	layout = {},
	root_info = {},
	load_fonts
}) {
	// console.log("CTX in RenderPage", ctx);
	return (
		<QueryClientProvider client={queryClient}>
			{/* <h3>PageType: {data.type}</h3>
			<pre>{JSON.stringify(root_info, null, 2)}</pre> */}
			{root_info?.typebase === "document_dynamic" ? (
				<PageDynamicNew
					id={data.id}
					db={data.html}
					info={data.info}
					root_info={root_info}
					layout={layout}
					dydb={data.content}
					gs={gs}
					page_info={page_info}
					pageBeforeData={pageBeforeData}
					pageAfterData={pageAfterData}
					ctx={ctx}
					query={query}
					load_fonts={load_fonts}
				/>
			) : <Page
				id={data.id}
				db={data.html}
				info={data.info}
				root_info={root_info}
				layout={layout}
				dydb={data.content}
				gs={gs}
				page_info={page_info}
				pageBeforeData={pageBeforeData}
				pageAfterData={pageAfterData}
				ctx={ctx}
				query={query}
				load_fonts={load_fonts}
			/>}
		</QueryClientProvider>
	);
}
